export const SET_SELECTED_STATUS = 'selectedStatus';
export const SET_SEARCH_TEXT = 'searchText';
export const SET_CATALOGO = 'catalogo';
export const CLEAR_FILTERS = 'clearFilters';
